import NotFound from './NotFound';
export default NotFound;
export { default as NotFound } from './NotFound';